.wrap {
  padding: 64px 30px 0;
  text-align: center;
}
.photoFrame {
  width: min(78%, 296px);
  margin: 0 auto;
  aspect-ratio: 3 / 4;
  border: 1px solid var(--rule-2);
  border-radius: 160px 160px 20px 20px;
  overflow: hidden;
  background: var(--sand);
  box-shadow: 0 12px 30px rgba(120, 100, 70, 0.1);
}
.photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.placeholder {
  width: 100%;
  height: 100%;
}
.names {
  margin-top: 24px;
  display: grid;
  gap: 13px;
  justify-items: center;
}
.row {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 9px;
}
.parents {
  font-size: 20px;
  color: var(--ink-4);
}
.relation {
  font-size: 14px;
  color: var(--muted-2);
}
.given {
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 21px;
  letter-spacing: 1px;
  color: var(--ink-2);
}
